import React, { Component } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import RejectUpdateRequestModal from "./RejectUpdateRequestModal";

class CompanyUpdateRequests extends Component {
    state = {
        requests: [],
        loading: true,
        error: null,
        showRejectModal: false,
        rejectId: null
    };

    componentDidMount() {
        axios.get("/api/company-update-requests?status=Invitado")
            .then(res => {
                console.log(res.data);
                this.setState({
                    requests: res.data.data,
                    current_person: res.data.current_person,
                    loading: false
                });
            })
            .catch(err => {
                let msg = "Error al cargar las solicitudes";
                if (err.response && err.response.data && err.response.data.message) {
                    msg = err.response.data.message;
                }
                this.setState({ error: msg, loading: false });
            });
    }

    render() {
        const { requests, loading, error, current_person, showRejectModal } = this.state;
        if (loading) return <div> </div>;
        if (error) return <div className="alert alert-danger">{error}</div>;
        if (!requests.length || !current_person) return null;

        // Solo mostrar solicitudes con diferencias
        const diffRequests = requests.map(req => {
            const diffs = [];
            if (req.rfc !== current_person.rfc) {
                diffs.push({
                    field: 'RFC',
                    from: current_person.rfc,
                    to: req.rfc
                });
            }
            if (req.fiscal_name !== current_person.fiscal_name) {
                diffs.push({
                    field: 'Razón Social',
                    from: current_person.fiscal_name,
                    to: req.fiscal_name
                });
            }
            if (req.person_type !== current_person.person_type) {
                diffs.push({
                    field: 'Tipo de persona',
                    from: current_person.person_type,
                    to: req.person_type
                });
            }
            if (req.address1 !== current_person.address1) {
                diffs.push({
                    field: 'Dirección',
                    from: current_person.address1,
                    to: req.address1
                });
            }
            if (req.municipality_id !== current_person.municipality_id) {
                diffs.push({
                    field: 'Municipio',
                    from: current_person.municipio ? current_person.municipio.name : current_person.municipality_id,
                    to: req.municipio ? req.municipio.name : req.municipality_id
                });
            }
            if (req.zipcode !== current_person.zipcode && (req.zipcode || current_person.zipcode)) {
                diffs.push({
                    field: 'C.P.',
                    from: current_person.zipcode,
                    to: req.zipcode
                });
            }
            return diffs.length > 0 ? { req, diffs } : null;
        }).filter(Boolean);

        if (!diffRequests.length) return null;

        return (
  <> 
      {diffRequests.map(({ req, diffs }) => (
        <div className="alert alert-warning w-100 mb-3 p-0" role="alert" key={req.id} style={{ minWidth: '100%', background: '#FFE6BC' ,borderLeft: '6px solid #FEA600' ,borderTop:'none',borderBottom:'none',borderRight:'none'}}>
          <div className="d-flex align-items-center px-4 pt-3 pb-0">
          <span className="flaticon2-warning mr-2 icon-3x" style={{ color: '#CC8603' }}></span>
            <span className="fw-bold" style={{ fontWeight: 600, fontSize: 12, color: '#CC8603' }}>
              Se requiere tu autorización para realizar cambios en los datos de tu empresa. Por favor, verifica la información.
            </span>
          </div>
            <div className="table-responsive p-4 pt-2 pb-4">
                <table className="table   mb-0" style={{ background: 'transparent', color: '#CC8603' }}>
                    <thead style={{ color: '#CC8603', background: 'none' }}>
                        <tr style={{ background: 'none', color: '#CC8603' }}>
                            <th style={{ color: '#CC8603' ,borderBottom: '1px solid #CC8603', backgroundColor: 'none'}}>Fecha de solicitud</th>
                            <th style={{ color: '#CC8603' ,borderBottom: '1px solid #CC8603', backgroundColor: 'none'}}>Solicitado por</th>
                            <th style={{ color: '#CC8603' ,borderBottom: '1px solid #CC8603', backgroundColor: 'none'}}>Descripción</th> 
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td style={{ verticalAlign: 'middle', color: '#CC8603' }}>{req.created_at ? req.created_at.substring(0, 16).replace('T', ' ') : ''}</td>
                        <td style={{ verticalAlign: 'middle', fontWeight: 600, color: '#CC8603' }}>{req.from_person.fiscal_name}</td>
                        <td style={{ color: '#CC8603' }}>
                            <ul className="mb-0" style={{ listStyle: 'none', paddingLeft: 0, color: '#CC8603' }}>
                            {diffs.map(diff => (
                                <li key={diff.field} style={{ marginBottom: 4, color: '#CC8603' }}>
                                Cambiar el contenido del campo <strong style={{ color: '#CC8603' }}>{diff.field}</strong>: <span style={{ color: '#CC8603', fontWeight: 600 }}>{diff.from}</span> por <span style={{ color: '#CC8603', fontWeight: 600 }}>{diff.to}</span>
                                </li>
                            ))}
                            </ul>
                        </td>
                        
                        </tr>
                    </tbody>
                </table>
                <div className="text-right mt-4">
                <button className="btn btn-danger btn-sm mr-5" onClick={() => this.handleReject(req.id)}>
                        <i className="fa fa-times"></i> Rechazar
                        </button>
                <button className="btn btn-primary btn-sm me-2" onClick={() => this.handleAccept(req.id)}>
                        <i className="fa fa-check"></i> Aceptar
                        </button>
                        
                </div>
            </div>
        </div>
      ))} 
    <RejectUpdateRequestModal
      show={this.state.showRejectModal}
      onClose={() => this.setState({ showRejectModal: false, rejectId: null })}
      onConfirm={this.handleRejectConfirm}
    />
  </>
);

    }



 

    handleAccept = (id) => {
        Swal.fire({
            title: 'Has aceptado los cambios propuestos',
            text: '¿Deseas confirmarlos y aplicarlos a los datos de tu empresa?',
            icon: 'warning',
            showConfirmButton: true, 
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Aceptar', 
            reverseButtons: true,
            showCancelButton: true,
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary" 
            }
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post('/api/company-update-requests/update', { id, status: 'Aceptado' }, { headers: { 'Content-Type': 'application/json' } })
                    .then(res => { 
                        Swal.fire({ 
                            text: 'Los datos han sido actualizados',
                            icon: 'success',  
                            showConfirmButton: false, 
                            reverseButtons: true,  
                            customClass: {
                                popup: 'my-swal-height'
                            }
                        })  
                        this.componentDidMount();  
                    })
                    .catch(() => {
                        Swal.fire('Error', 'No se pudo actualizar la información.', 'error');
                    });
            }
        });
    }

    handleReject = (id) => {
        this.setState({ showRejectModal: true, rejectId: id });
    }

    handleRejectConfirm = (reason) => {
        const { rejectId } = this.state;
        axios.post('/api/company-update-requests/update', { id: rejectId, status: 'Rechazado', rejected_message: reason }, { headers: { 'Content-Type': 'application/json' } })
            .then(res => {
                Swal.fire({
                    icon: 'info',
                    title: 'Has rechazado la solicitud de modificación de los datos de tu empresa',
                    html: ` 
                            <div style="  color:#444; margin-bottom:8px; text-align:center;">
                                Si deseas realizar los cambios por tu cuenta,<br />puedes hacerlo dando<br />click en el botón de <b>Modificar</b>.
                            </div> ` , 
                    showConfirmButton: true, 
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Modificar datos de mi empresa', 
                    reverseButtons: true,
                    showCancelButton: true,
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary",
                        cancelButton: "btn font-weight-bold btn-secondary" 
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = '/account';
                    }
                });
                this.setState({ showRejectModal: false, rejectId: null });
                this.componentDidMount();
            })
            .catch(() => {
                Swal.fire('Error', 'No se pudo rechazar la solicitud.', 'error');
                this.setState({ showRejectModal: false, rejectId: null });
            });
    }

}

export default CompanyUpdateRequests;
